/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPercentage10 = createReactComponent("outline", "percentage-10", "IconPercentage10", [["path", { "d": "M12 3c1.92 0 3.7 .601 5.16 1.626l-5.16 7.374z", "fill": "currentColor", "stroke": "none", "key": "svg-0" }], ["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-1" }]]);

export { IconPercentage10 as default };
//# sourceMappingURL=IconPercentage10.mjs.map
